import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type IQualifyingProvider = {
  id: number
  name: string | null
  location: string | null
  email: string | null
}

export type SelectedPurse = {
  amount: number
  purse_id: number
  name: string
  isSelected: boolean
  hasBeenManuallyEdited: boolean
}

export type ProviderCategory = { id: number; amount: number }

export interface ProviderState {
  selectedProvider: IQualifyingProvider
  paymentAmount: number
  purses: SelectedPurse[]
  documents: string[]
  uploadedDocumentNames?: string[]
  expenseType: ExpenseType
  submitted?: boolean
  categories: ProviderCategory[]
}

export type ExpenseType = {
  invoiceNumber?: string
  comments?: string
  expenseCategories?: string[]
}

const initialState: ProviderState = {
  selectedProvider: {
    email: "",
    id: 0,
    location: "",
    name: "",
  },
  paymentAmount: 0,
  expenseType: {
    invoiceNumber: '',
    comments: '',
  },
  categories: [],
  uploadedDocumentNames: [],
  purses: [],
  documents: [],
  submitted: false,
}

const providerPaySlice = createSlice({
  name: 'providerPayApplication',
  initialState,
  reducers: {
    setSelectedProvider: (
      state,
      action: PayloadAction<IQualifyingProvider>
    ) => {
      state.selectedProvider = action.payload
    },
    setPaymentAmount: (state, action: PayloadAction<number>) => {
      state.paymentAmount = action.payload
    },
    setPayProviderPurses: (state, action: PayloadAction<SelectedPurse[]>) => {
      state.purses = action.payload
    },
    setPayProviderDocuments: (state, action: PayloadAction<string[]>) => {
      state.documents = action.payload
      state.uploadedDocumentNames = []
    },
    setProviderCategories: (
      state,
      action: PayloadAction<ProviderCategory[]>
    ) => {
      state.categories = action.payload
    },
    setPayProviderUploadedDocumentNames: (
      state,
      action: PayloadAction<string[]>
    ) => {
      state.uploadedDocumentNames = action.payload
    },
    setPayProviderExpenseType: (state, action: PayloadAction<ExpenseType>) => {
      state.expenseType = action.payload
    },
    setPayProviderSubmitted: (state, action: PayloadAction<boolean>) => {
      state.submitted = action.payload
    },
    setPayProviderState: (
      state,
      action: PayloadAction<Partial<ProviderState>>
    ) => {
      return { ...state, ...action.payload }
    },
    resetPayProviderData: () => initialState,
  },
})


export const {
  setSelectedProvider,
  setPaymentAmount,
  setProviderCategories,
  setPayProviderDocuments,
  setPayProviderUploadedDocumentNames,
  setPayProviderPurses,
  setPayProviderExpenseType,
  setPayProviderSubmitted,
  setPayProviderState,
  resetPayProviderData,
} = providerPaySlice.actions

export default providerPaySlice.reducer
